module.exports = __webpack_public_path__ + "img/dl_bg.f4f2ae66.png";